"use strict";
module.exports = require("./lib/client/phone");
